(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.directive('editableImage', ['AppConfig', 'FileUploader', 'Alert', '$timeout', EditableImageFn]);

    /* editable image directive */
    function EditableImageFn(AppConfig, FileUploader, Alert, $timeout) {
        var directive = {
            scope: {                
                minWidth: "=?", // min width of the cropped image
                minHeight: "=?", // min height of the cropped image
                useLogoPlaceholder: "=?", // use the default logo instead of the avatar image as placeholder
                userId: '@?',
                licenceId: '@?',
                userImageTempFile: "="
            },
            restrict: 'E',
            replace: true,
            templateUrl: '/app/global/templates/rf-global-editable-image.template.html',
            compile: function () {
                return {
                    pre: function (scope, element) {
                        var isUploading = false;
                        var onLoadTimeoutUnbinder = null;
                        scope.selectedImage = '';
                        scope.selectedCroppedImage = '';
                        scope.imageCropper = null;
                        scope.imageMinSizeError = false;
                        scope.aspectRatio = 1;
                        scope.viewimgsrc = null;

                        activate();

                        scope.onImageChange = function () {
                            scope.imageMinSizeError = scope.minHeight && scope.imageCropper.cropImageHeight < scope.minHeight || scope.minWidth && scope.imageCropper.cropImageWidth < scope.minWidth;
                        };

                        scope.startUpload = function (item) {
                            isUploading = true;
                            item.upload();
                        };

                        scope.uploader.onAfterAddingFile = function (item) {
                            // open modal to crop the image
                            var reader = new FileReader();
                            reader.readAsDataURL(item._file);

                            reader.onload = function (event) {
                                onLoadTimeoutUnbinder = $timeout(function () {
                                    scope.selectedImage = event.target.result;
                                });
                            };

                            // open modal with static backdrop -> modal stays open if user clicks outside of modal
                            angular.element("#cropDiv_" + scope.$id).modal(
                                {
                                    backdrop: 'static',
                                    keyboard: false
                                });
                        };

                        scope.uploader.onBeforeUploadItem = function (item) {
                            // replace selected file with byte array of cropped image 
                            var blob = dataURItoBlob(scope.selectedCroppedImage);
                            item._file = blob;
                        };

                        scope.uploader.onErrorItem = function (item, response, status, headers) {
                            isUploading = false;
                            Alert.danger('Failed to upload image: ' + status + ' ' + response);
                            clearQueue();
                        };

                        scope.uploader.onSuccessItem = function (item, response, status, headers) {
                            // cropped image has been sent to server to create a base64 link
                            // replace directive variables with new values, values will be saved when entity is saved                            
                            scope.viewimgsrc = URL.createObjectURL(item._file);
                            scope.userImageTempFile = response;

                            isUploading = false;
                            clearQueue();
                        };

                        var timeoutUnbinder = $timeout(function () {
                            // clear selection and cropped image when modal window is closed/hidden
                            angular.element("#cropDiv_" + scope.$id).on('hidden.bs.modal', function () {
                                clearQueue();
                            });

                            // when user clicks on edit-button, activate the click-method for the actual input field to start upload
                            angular.element("#dirSelect_" + scope.$id).on('click', function () {
                                angular.element("#dirUplInput_" + scope.$id).click();
                            });
                        }, 0);

                        // on destroy
                        scope.$on('$destroy', function () {
                            $timeout.cancel(timeoutUnbinder);
                            if (onLoadTimeoutUnbinder) {
                                $timeout.cancel(onLoadTimeoutUnbinder);
                            }
                            angular.element("#cropDiv_" + scope.$id).off('hidden.bs.modal');
                            angular.element("#dirSelect_" + scope.$id).off('click');
                        });

                        // activate
                        function activate() {
                            setViewImageSrc();

                            // set default values if not defined to be able to use it in template
                            if (!scope.minWidth)
                                scope.minWidth = 0;

                            if (!scope.minHeight)
                                scope.minHeight = 0;

                            scope.aspectRatio = scope.minWidth / scope.minHeight;

                            scope.uploader = new FileUploader({
                                url: AppConfig.ApiUrl + '/api/images/upload'
                            });

                            // set file-image filter
                            scope.uploader.filters.push({
                                name: 'imageFilter',
                                fn: function (item, options) {
                                    var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
                                    if ('|jpg|png|jpeg|'.indexOf(type) !== -1) {
                                        return true;
                                    }
                                    else {
                                        Alert.danger('Selected file is not a supported image (jpg/png)!');
                                        return false;
                                    }
                                }
                            });

                            // set file-size filter
                            scope.uploader.filters.push({
                                name: 'sizeFilter',
                                fn: function (item, options) {
                                    if (item.size <= 2097152) {//2MB in bytes
                                        return true;
                                    }
                                    else {
                                        Alert.danger('Selected image exceeds the supported file size (2MB)!');
                                        return false;
                                    }
                                }
                            });
                        }

                        // set image url
                        function setViewImageSrc() {
                            if (scope.userId) { 
                                scope.viewimgsrc = AppConfig.ApiUrl + '/api/images/users/' + btoa(scope.userId) + '/true?r=' + Math.round(Math.random() * 999999);
                            }
                            else if(scope.licenceId) {
                                scope.viewimgsrc = AppConfig.ApiUrl + '/api/administrations/pageLogoLicence/' + scope.licenceId + '/false?thumbwidth=300&thumbheight=300&r=' + Math.round(Math.random() * 999999);
                            }
                            else if (scope.useLogoPlaceholder) {
                                scope.viewimgsrc = "/app/images/logo_ringfoon.png";
                            }
                            else {
                                scope.viewimgsrc = "/app/images/no-avatar.png";
                            }
                        }

                        // clear upload queue
                        function clearQueue() {
                            if (isUploading === false) {
                                scope.uploader.clearQueue();
                                angular.element("#dirUplInput_" + scope.$id).val(null);
                                scope.selectedImage = '';
                                scope.selectedCroppedImage = '';
                            }
                        }

                        // convert image bytes to object URL
                        function bytesToObjectUrl(imgbytes, mimetype) {
                            var binary = atob(imgbytes);
                            var array = [];
                            for (var i = 0; i < binary.length; i++) {
                                array.push(binary.charCodeAt(i));
                            }
                            var blob = new Blob([new Uint8Array(array)], { type: mimetype });
                            return URL.createObjectURL(blob);
                        }

                        // convert base64-link to blob object
                        function dataURItoBlob(dataURI) {
                            var binary = atob(dataURI.split(',')[1]);
                            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
                            var array = [];
                            for (var i = 0; i < binary.length; i++) {
                                array.push(binary.charCodeAt(i));
                            }
                            return new Blob([new Uint8Array(array)], { type: mimeString });
                        }
                    }
                };
            }
        };
        return directive;
    }
})();